import { fuzzyMatch } from './fuzzy-match'

const equals = (pattern, str) => str === pattern
const matches = (pattern, str) => fuzzyMatch({ str, pattern })

export {
  equals,
  matches
}
